import { isEmpty } from 'lodash';
import { core } from '@/restore/well-logs/core';
import { generateGridData } from '../../components/WellLoggingOperations/Toolbar/modals/Core/helpers';

export const coreReportModel = {
    name: 'coreReport',
    state: {
        core: {}, // Данные по каждому wellId
        isLoading: {}, // Отдельный флаг загрузки для каждого wellId
        columnsDef: {}, // Сохраняем columnsDef для каждого wellId
        rowData: {}, // Сохраняем rowData для каждого wellId
        coreTypesTitles: {},
    },
    reducers: {
        setIsLoading(state, { wellId, isLoading }) {
            return {
                ...state,
                isLoading: { ...state.isLoading, [wellId]: isLoading },
            };
        },
        setCoreTypesTitles(state, payload) {
            return {
                ...state,
                coreTypesTitles: payload,
            };
        },
        /*
            Обновление данных по керну для конкретного wellId
        */
        setCore(state, payload) {
            const { wellId, data } = payload;

            const newCore = { [wellId]: data };

            // Динамически создаем `columnsDef` и `rowData` для данного wellId
            const { columnsDef, rowData, coreTypesTitles } = generateGridData(data[wellId], core.groupsByWells[wellId]);

            return {
                ...state,
                core: { ...state.core, ...newCore },
                columnsDef: { ...state.columnsDef, [wellId]: columnsDef },
                rowData: { ...state.rowData, [wellId]: rowData },
                coreTypesTitles: { ...state.coreTypesTitles, [wellId]: coreTypesTitles },
            };
        },
    },
    effects: dispatch => ({
        async getCoreReport({ wellId, wellKey }) {
            if (!coreReportModel.state.rowData[wellId] && !coreReportModel.state.columnsDef[wellId])
                try {
                    dispatch.coreReport.setIsLoading({ wellId, isLoading: true });
                    let data = {};
                    if (!core.dataByWells[wellId]) data = await core.getData(wellId, wellKey);
                    else data.coreDataByWell = core.dataByWells;
                    if (!isEmpty(data)) {
                        dispatch.coreReport.setCore({ wellId, data: data?.coreDataByWell });
                    }
                } catch (error) {
                    console.error(`Error fetching core report for wellId: ${wellId}`, error);
                } finally {
                    dispatch.coreReport.setIsLoading({ wellId, isLoading: false });
                }
        },
    }),
};
